import React, { useEffect, useState } from "react";
import styles from "../../assets/css/admin/layout.module.css";
import SideBar from "./SideBar";
import axios from "axios";
import {baseUrl} from "../../baseUrl"
import { Link, useParams } from "react-router-dom";
import {useAuth} from "../../AuthContext"
import { useSidebar } from "../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import {toast} from "react-toastify"
import api from "../../api";

const EditAdmin = () => {
    const { logout,user } = useAuth();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [name,setName]=useState("")
    const [email,setEmail]=useState("")
    const [password,setPassword]=useState("")
    const [confirmPassword,setConfirmPassword]=useState("")
    const [role,setRole]=useState("")
    const [username,setUsername]=useState("")
    const data={name,email,password,role,username}
    const [message,setMessage]=useState("")
    const params=useParams()
    useEffect(() => {
        const timer = setTimeout(() => {
          setMessage(false);
        }, 4000);
        return () => clearTimeout(timer);
      }, [message]);
    useEffect(()=>{
        api.get(`${baseUrl}/admin/get/?id=${params.id}`)
        .then(res=>{
            let resData=res.data[0]
            setName(resData.name)
            setEmail(resData.email)
            setRole(resData.role)
            setUsername(resData.username)
            setPassword(resData.password)
            setConfirmPassword(resData.password)
        })
        .catch(err=>console.log(err))
    },[])

    const handleSubmit=(e)=>{
      if(password!==confirmPassword){
        setMessage('Password Not matched with Confirm Password')
      }else{
        api.post(`${baseUrl}/admin/update`,{...data,id:params.id})
        .then(res=>{
            if(res.data==="success"){
                setMessage("Admin Updated")
            }
        })
        .catch(err=>{
          toast.error(err?.response?.data.message || "Something went wrong")
          console.log(err)
        })
      }
    }

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside
        className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}
      >
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
        <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <div className="flex-grow-1 d-flex">
              <li className="breadcrumb-item">
                <Link to="/admin/dashboard" className="text-decoration-none">
                  Dashboard
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link  to="/admins" className="text-decoration-none">
                  All admins
                </Link>
              </li>
              <li className="breadcrumb-item active">Edit</li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>
        <div
          className="container"
          style={{ backgroundColor: "#F3F8FB", padding: "40px" }}
        >
          <div className="bg-white p-4">
            <h4>Edit Admin</h4>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="adminName" className="form-label">
                  Admin Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="adminName"
                  placeholder="Enter Name"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="adminEmail" className="form-label">
                  Admin Email
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="adminEmail"
                  placeholder="Enter Email"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="passoword" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="passoword"
                  placeholder="Enter Password"
                  onChange={(e)=>setPassword(e.target.value)}
                  value={password}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="confirmPassword" className="form-label">
                  Confirm Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  placeholder="Confirm Password"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  value={confirmPassword}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <label htmlFor="assignRoles" className="form-label">
                  Assign Roles
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="assignRoles"
                  placeholder="Enter Password"
                  onChange={(e) => setRole(e.target.value)}
                  value={role}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="adminUsername" className="form-label">
                  Admin Username
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="adminUsername"
                  placeholder=""
                  onChange={(e) => setUsername(e.target.value)}
                  value={username}
                />
              </div>
            </div>
            {
                message&&
                <div
              className="alert alert-warning alert-dismissible fade show mt-3"
              role="alert"
            >
                {message}
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
                onClick={()=>setMessage(false)}
              ></button>
            </div>
            }
            <button onClick={handleSubmit} className="btn btn-primary btn-sm mt-4">
              Update
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default EditAdmin;
